module.exports = __webpack_public_path__ + "img/multiple-docs.53443f04.svg";